import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    header: {
        backgroundColor: theme?.tableProperties?.headerBackgroundColor,
    },
    title: {
        fontWeight: 600,
        textAlign: 'center',
        color: theme?.tableProperties?.textColor,
        marginLeft: theme.spacing(2),
    },
    closeImg: {
        color: theme?.tableProperties?.closeIconColor,
    },
    actionContainer: {
        backgroundColor: theme?.tableProperties.actionsBackground,
    },
    icon: {
        width: '35px',
        height: '35px',
    },
    tableDetailsContainer: {
        backgroundColor: theme?.tableProperties.actionsBackground,
    },
    tableNumber: {
        color: theme?.tableProperties.tableNumberTextColor,
    },
    checkContainer: {
        backgroundColor: theme?.tableProperties.actionsBackground,
    },
    bookingName: {
        color: theme?.tableProperties.checkTextColor,
    },
    message: {
        color: theme?.tableProperties.message,
        textAlign: 'center',
        marginBottom: '10px',
    },
    button: {
        backgroundColor: theme?.tableProperties?.primaryButtonBackgroundColor,
        color: theme?.tableProperties?.primaryButtonTextColor,
        width: '40%',
    },
    secondaryButton: {
        backgroundColor: theme?.tableProperties?.secondaryButtonBackgroundColor,
        color: theme?.tableProperties?.secondaryButtonTextColor,
        borderColor: theme?.tableProperties?.secondaryButtonBorderColor,
        width: '40%',
    },
    tabsContainer: {
        width: '100%',
        height: '100%',
        backgroundColor: theme?.tableProperties.tabsContainerBackgroundColor,
    },
    ulStyle: {
        height: '4.5vh',
        backgroundColor: theme?.tableProperties.tabsBackgroundColor,
        borderRadius: '5px',
        padding: '5px',
    },
    actionBtn: {
        borderRadius: theme.spacing(0.5),
        borderWidth: '1px',
        borderColor: theme?.tableProperties.actionButtonBorderColor,
        borderStyle: 'solid',
    },
    selectedActionBtn: {
        backgroundColor: theme?.tableProperties.selectedActionBackgroundColor,
        borderColor: theme?.tableProperties.selectedActionBorderColor,
    },
    actionBtnTxt: {
        fontWeight: 600,
        marginLeft: theme.spacing(0.5),
    }
}));

export default useStyles;
